import type { Player } from '@dicetechnology/doris-core';
import type { SubtitlePolicy } from '@dicetechnology/doris-plugin-subtitle-policy';

import { DiceReceiverManager } from '../services';

import { throwError } from './throwError';

let previousSubtitlePolicy: SubtitlePolicy | undefined = undefined;

export const configureSubtitlePolicyPlugin = async (player: Player): Promise<void> => {
    const SUBTITLE_POLICY_PLUGIN_NAME = 'subtitle-policy';

    const diceReceiverManager = DiceReceiverManager.getInstance();
    const { subtitlePolicy } = diceReceiverManager.getSettings() ?? throwError('Invalid state!');

    const shouldUseSubtitlePolicyPlugin = previousSubtitlePolicy || (subtitlePolicy && Object.keys(subtitlePolicy).length > 0);
    if (!shouldUseSubtitlePolicyPlugin) {
        return;
    }

    const { SubtitlePolicyPlugin } = await import('@dicetechnology/doris-plugin-subtitle-policy');

    const existingPlugin = player.getPluginByType(SubtitlePolicyPlugin);
    if (!existingPlugin) {
        player.addPlugin({
            name: SUBTITLE_POLICY_PLUGIN_NAME,
            Plugin: SubtitlePolicyPlugin,
            config: {
                subtitlePolicy
            }
        });
    } else {
        existingPlugin.setSubtitlePolicy(subtitlePolicy ?? {});
    }

    // Storing previous subtitle policy here so we can switch
    // from a realm with subtitle policy to one without.
    previousSubtitlePolicy = subtitlePolicy;
};
